<template>
  <div class="mall-item-box">
    <!-- <div class="state state-bj1" v-if="itemData.status === 1">
      <span>{{$t('mall.status1')}}</span>
    </div>
    <div class="state state-bj2" v-if="itemData.status === 2">
      <span>{{$t('mall.status2')}}</span>
    </div>
    <div class="state state-bj3" v-if="itemData.status === 3">
      <span>{{$t('mall.status3')}}</span>
    </div>
    <div class="state state-bj3" v-if="itemData.status === 4">
      <span>{{$t('mall.status4')}}</span>
    </div> -->
    <!-- <div class="state state-bj1">
      <span>{{ itemData.summary.status }}</span>
    </div> -->
    <div class="img-box">
      <img :src="itemData.image" alt="mall-item" />
      <div class="info">
        <p class="title1">{{ itemData.title }}</p>
        <p class="title2">{{ itemData.summary.chainInfo.network }}</p>
        <p class="title3">{{ itemData.summary.chainInfo.issuer }}</p>
      </div>
    </div>
    <div class="info-box">
      <div class="c-flex-space-between mb12">
        <p class="title1">{{ $t("mall.assetType") }}</p>
        <p class="title2">
          {{ itemData.summary.type === "goods" ? $t("mall.typeGoods") : $t("mall.typeService") }}
        </p>
      </div>
      <div class="c-flex-space-between mb12">
        <p class="title1">{{ $t("mall.assetPrice") }}</p>
        <p class="title2">{{ itemData.summary.valueInfo.firstValue }}</p>
      </div>
      <div class="c-flex-space-between mb12">
        <p class="title1">{{ $t("mall.issuanceTotal") }}</p>
        <p class="title2">{{ itemData.summary.valueInfo.totalValue }}</p>
      </div>
      <div class="c-flex-space-between mb12">
        <p class="title1">{{ $t("mall.delivery") }}</p>
        <p class="title2">{{ itemData.summary.serviceInfo.DeliveryArea }}</p>
      </div>
      <div class="c-flex-space-between">
        <p class="title1">{{ $t("mall.payPrice") }}</p>
        <p class="title2">{{ itemData.summary.valueInfo.minBuyAomout }}</p>
      </div>
    </div>
    <div class="btn-box">
      <div class="btn1" v-if="itemData.summary.serviceInfo.mallUrl"
        @click="jumpClick(itemData.summary.serviceInfo.mallUrl)">
        {{ $t("mall.mallUrl") }}
      </div>
      <div class="btn2" @click="itemClick(itemData)">
        {{ $t("mall.view_details") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    itemClick(val) {
      this.$router.push({ path: "/mall/oldDetail", query: { cateCode: val.cateCode } });
    },
    jumpClick(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.mall-item-box {
  width: 100%;
  padding: 24px;
  cursor: pointer;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 12px;
  position: relative;

  .state {
    top: 0;
    right: 0;
    text-align: center;
    line-height: 30px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    position: absolute;
    // width: 70px;
    height: 30px;
    padding: 0 8px;
    border-radius: 0px 12px 0px 12px;
  }

  .state-bj1 {
    background-color: #3370ff;
  }

  .state-bj2 {
    background-color: #ff8800;
  }

  .state-bj3 {
    background-color: #bbbfc4;
  }

  .img-box {
    gap: 20px;
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid #e2e3e3;

    img {
      width: 120px;
      height: 120px;
      border-radius: 12px 12px 12px 12px;
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 20px;
        color: #333333;
      }

      .title2 {
        padding: 0 8px;
        height: 28px;
        width: fit-content;
        line-height: 28px;
        background: #e1eaff;
        border-radius: 4px 4px 4px 4px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #4063ff;
      }

      .title3 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }

  .info-box {
    padding: 20px 0;
    border-bottom: 1px solid #e2e3e3;

    .title1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
    }

    .title2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 16px;
      color: #333333;
    }
  }

  .btn-box {
    gap: 16px;
    display: flex;
    padding-top: 20px;

    .btn1 {
      flex: 1;
      height: 52px;
      line-height: 52px;
      text-align: center;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #4063ff;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #4063ff;
    }

    .btn2 {
      flex: 1;
      height: 52px;
      line-height: 52px;
      text-align: center;
      background: #4063ff;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
    }
  }
}
</style>
